<template>
  <CoreCard
    :icon="icon"
    :wide="true"
    :title="title"
    :center="true"
    :to="to"
    :bg-gray="true"
    :hover-highlight="true"
    class="w-full flex flex-col md:min-w-sm max-w-md"
  >
    <div class="flex flex-col items-center flex-grow">
      <div class="text-center flex-grow flex items-baseline mb-8 md:mb-16">
        <p
          class="max-w-xs text-4 md:text-3"
          v-text="innerText"
        />
      </div>
      <CoreButton
        :bg-gray="true"
        :text="ctaText"
        @click="handleClick"
      />
    </div>
  </CoreCard>
</template>

<script>
export default {
  name: 'HomeCard',

  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    innerText: {
      type: String,
      default: '',
    },
    to: {
      type: [Object, String],
      default: null,
    },
    ctaText: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleClick() {
      if (this.to) {
        if (typeof this.to === 'string') window.open(this.to, '_blank');
        if (typeof this.to === 'object') this.$router.push(this.to);
      }
    },
  },
};
</script>
